import React, { useEffect, useRef } from 'react';
import './Modal.css';

const Modal = ({ isOpen, closeModal, children }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') closeModal();
    };

    document.addEventListener('keydown', handleKeyDown);
    dialogRef.current?.focus();
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeModal]);

  if (!isOpen) return null;

  return (
    <div className="modal-root">
      <div className="modal-overlay" onClick={closeModal} aria-hidden="true" />
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="success-title"
        ref={dialogRef}
        tabIndex="-1"
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
